import React, { useContext, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { QueryCache, ReactQueryCacheProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import deDE from "antd/es/locale/de_DE";
import enUS from "antd/es/locale/en_US";

import { AuthProvider } from "../context/AuthContext";
import en from "../locales/en.json";
import de from "../locales/de.json";
import { LangContext } from "../context/LangContext";

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const AppProviders: React.FunctionComponent = ({ children }) => {
  const [antdLocale, setAntdLocale] = useState(deDE);
  const [messages, setMessages] = useState(de);
  const langContext = useContext(LangContext);

  useEffect(() => {
    if (langContext.locale!.startsWith("en")) {
      setAntdLocale(enUS);
      setMessages(en);
    } else {
      setAntdLocale(deDE);
      setMessages(de);
    }
  }, [langContext.locale]);

  return (
    <ReactQueryCacheProvider queryCache={queryCache}>
      <IntlProvider locale={langContext.locale!} messages={messages} textComponent="span">
        <ConfigProvider locale={antdLocale}>
          <Router>
            <AuthProvider>{children}</AuthProvider>
          </Router>
        </ConfigProvider>
      </IntlProvider>
    </ReactQueryCacheProvider>
  );
};

export default AppProviders;
